/** Animated placeholder shown while the illustrative growth curve loads. */
export default function VectorCapitalChartLoader() {
  return (
    <div
      className="vector-capital-chart-loader"
      role="status"
      aria-busy="true"
      aria-label="Building growth curve"
    >
      <div className="vector-capital-chart-loader-stage" aria-hidden="true">
        <div className="vector-capital-chart-loader-grid">
          <span /><span /><span /><span /><span />
        </div>
        <svg
          className="vector-capital-chart-loader-svg"
          viewBox="0 0 480 140"
          preserveAspectRatio="none"
        >
          <path
            className="vector-capital-chart-loader-path vector-capital-chart-loader-path--bench"
            d="M0,118 C72,112 140,96 210,88 S340,72 480,58"
          />
          <path
            className="vector-capital-chart-loader-path vector-capital-chart-loader-path--scenario"
            d="M0,122 C64,118 120,88 190,82 S310,38 400,22 S450,14 480,10"
          />
        </svg>
        <div className="vector-capital-chart-loader-shimmer" />
        <p className="vector-capital-chart-loader-caption">
          Building Growth Curve
          <span className="vector-capital-chart-loader-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </div>
  );
}
